import { Expose, Transform, Type } from "class-transformer";
import { IsString } from "class-validator";
import { CreateFileDto } from "@/core/features/file/create-file.dto";
import { parseAppDate, toUTCDate } from "@/utils/dates/dateFormats";
import { setTimeToMidday, toLocaleTimezone } from "@/utils/dates/dateUtils";

export class CreateUserChangeHolidayDto {
  @Expose()
  @IsString()
  userId: string;

  @Expose()
  @IsString()
  collectiveAgreementHolidayId: string;

  @Expose()
  @Transform(({ value }) => {
    const parsedUtc = parseAppDate(value, false);
    const localDate = toLocaleTimezone(parsedUtc);
    const localMidday = setTimeToMidday(localDate);
    return toUTCDate(localMidday);
  })
  newDate: string;

  @Expose()
  @Type(() => CreateFileDto)
  file: CreateFileDto;
}
